/** '2026-11-03' → '3.11.2026'. */
export const dayLabel = (day: string): string => `${Number(day.slice(8, 10))}.${day.slice(5, 7)}.${day.slice(0, 4)}`;

/** 'PL10105000997603123456789123' → 'PL10 1050 0099 7603 1234 5678 9123' (groups of four, as banks print it). */
export const ibanLabel = (iban: string): string => iban.replace(/(.{4})(?=.)/g, '$1 ');

/** "3 operacje", "1 operacja", "5 operacji" (Polish plural). */
export function operationsLabel(n: number): string {
  const word = n === 1 ? 'operacja' : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 12 || n % 100 > 14) ? 'operacje' : 'operacji';
  return `${n} ${word}`;
}

/** One file's answer of "Wgraj wyciąg" as a sentence. */
export function uploadResultText(r: { status: string; entries: number; newEntries: number; message?: string }): string {
  if (r.status === 'already_imported') return 'już wczytany — nic nie zmieniono';
  if (r.status === 'error') return r.message ?? 'nie udało się wczytać';
  return r.newEntries === r.entries ? `wczytano ${operationsLabel(r.entries)}` : `wczytano ${operationsLabel(r.entries)}, nowe: ${r.newEntries}`;
}
